// Utilities
import isEmpty from '../../utility/isEmpty'
import { AppBrands, AppBrandDisplayRNameEnum, AppBrandDisplayNameEnum } from '../../constants'

export default {
  buttonTimeLimit (state) {
    return state.config.resendButtonTimerTimeOut * 1000
  },

  isServiceAvailable (state) {
    return state.serviceAvailable === true
  },

  demographics (state) {
    return state.config?.demographics
  },

  hasDemographicRace (state, getters) {
    return getters.demographics.includes('Race')
  },

  hasDemographicHeight (state, getters) {
    return getters.demographics.includes('Height')
  },

  hasDemographicWeight (state, getters) {
    return getters.demographics.includes('Weight')
  },

  hasDemographicSex (state, getters) {
    return getters.demographics.includes('Sex')
  },

  isEasyMoneyBrand () {
    return process.env.VUE_APP_AppBrand === AppBrands.esm
  },

  isCommunityChoiceBrand () {
    return process.env.VUE_APP_AppBrand === AppBrands.ccf
  },

  isTitleMaxBrand () {
    return isEmpty(process.env.VUE_APP_AppBrand) || process.env.VUE_APP_AppBrand === AppBrands.tmx
  },

  isInstaLoanBrand () {
    return process.env.VUE_APP_AppBrand === AppBrands.inl
  },

  isTitleBucksBrand () {
    return process.env.VUE_APP_AppBrand === AppBrands.tbs
  },

  isSpeedyCashBrand () {
    return process.env.VUE_APP_AppBrand === AppBrands.spc
  },

  isRapidCashBrand () {
    return process.env.VUE_APP_AppBrand === AppBrands.rpc
  },

  isCheckSmartBrand () {
    return process.env.VUE_APP_AppBrand === AppBrands.chs
  },

  isCheckIntoCashBrand () {
    return process.env.VUE_APP_AppBrand === AppBrands.cic
  },

  brandNameWithR () {
    return AppBrandDisplayRNameEnum[process.env.VUE_APP_AppBrand]
  },

  brandNameWithoutR () {
    if (process.env.VUE_APP_AppBrand === AppBrands.esm) {
      return AppBrandDisplayNameEnum.esmName
    }

    return AppBrandDisplayNameEnum[process.env.VUE_APP_AppBrand]
  },

  brandDisplayName () {
    return AppBrandDisplayNameEnum[process.env.VUE_APP_AppBrand]
  },

  showCollateralProtection (state, getters, rootState, rootGetters) {
    return state.showCollateralProtection && rootGetters['applicationCustomer/isTitleLoanProduct']
  },

  showScanIdScreens (state, getters, rootState, rootGetters) {
    if (rootGetters['display/isPhoneOrTablet']) {
      return state.config.showScanIdScreensProduct.mobile && state.config.showScanIdScreens
    }

    return state.config.showScanIdScreensProduct.desktop && state.config.showScanIdScreens
  },

  customerIsEditing (state) {
    return state.editMode
  },

  editOrigin (state) {
    return state.editOrigin
  },

  isCcfiBrand (state, getters) {
    return getters.isSpeedyCashBrand || getters.isCheckSmartBrand || getters.isCheckIntoCashBrand || getters.isEasyMoneyBrand || getters.isCommunityChoiceBrand
  },

  isSkipCcfiFlow (state) {
    return state.applicationOptions ? state.applicationOptions.skipCcfiFlow : false
  },

  callConsentText (state, getters) {
    return state.config.consentText.callConsent.replaceAll('[brandName]', getters.brandNameWithR).replaceAll('[brandWithoutR]', getters.brandNameWithoutR)
  },

  emailConsentText (state, getters, rootState) {
    return state.config.consentText.emailConsent.replaceAll('[brandName]', getters.brandNameWithR).replaceAll('[customerEmail]', rootState.applicationCustomer.email || '')
  },

  smsConsentText (state, getters) {
    return state.config.consentText.smsConsent.replaceAll('[brandName]', getters.brandNameWithR).replaceAll('[brandWithoutR]', getters.brandNameWithoutR)
  },

  isPhoneOrTablet (state, getters, rootState) {
    return rootState.display.isMobileBrowser || rootState.display.isTabletBrowser
  },

  deviceType (state, getters, rootState) {
    if (rootState.display.isTabletBrowser) {
      return 'tablet'
    }

    if (rootState.display.isMobileBrowser) {
      return 'mobile'
    }

    return 'desktop'
  },

  useTranslucentScrim (state, getters, rootState) {
    return !rootState.display.isMobileBrowser || !getters.isAndroid
  },

  showExpensesScreen (state) {
    return state.showExpensesScreen
  },

  disableSelfAppraisal (state) {
    return state.config.disableSelfAppraisal || state.applicationOptions.disableSelfAppraisal
  },

  isMobileMoney (state, getters, rootState) {
    return !isEmpty(rootState.applicationRetailStore.mobileMoneyLocation) && state.config.enableMobileMoney
  },

  showAppointments (state, getters) {
    return state.applicationOptions.skipCcfiFlow || (!getters.isCcfiBrand && !getters.isMobileMoney)
  },

  setStore (state, getters, rootState) {
    return !getters.isMobileMoney && (!getters.isCcfiBrand || (state.applicationOptions.skipCcfiFlow && !rootState.applicationRetailStore.qrCodeScannedStore))
  },

  analyticStoreBrand (state, getters, rootState) {
    const mmType = rootState.applicationRetailStore.mobileMoneyType
    const mmStoreBrand = getters.isMobileMoney && !isEmpty(mmType) ? mmType : process.env.VUE_APP_AppBrand
    return AppBrandDisplayNameEnum[mmStoreBrand] || AppBrandDisplayNameEnum.tmx
  }
}
